import React, {Component} from 'react';
import _ from 'lodash';
import FacebookFeedListContainer from './FacebookFeedListContainer';
import { routeActions } from 'react-router-redux';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';

const container = connect(
  createSelector(
    (state) => ({
      subjects: _.get(state, 'subject.entities'),
      panel_row3_right: _.get(state, 'subject.panel_row3_right'),
    })
    ,
    (state) => {
      const {subjects, panel_row3_right} = state;
      const subjectId = _.get(panel_row3_right, 'data[0]')
      const subject = subjects[subjectId];
      return {
        subject,
      }
    }
  ),
  () => ({})
)

class NewsFeedListLayout extends Component {
  render() {
    const {dispatch, originDispatch, subject} = this.props;
    return (
      <div className="feed-lyout-main">
        <div className="feed-layout-title">
          <span className="margin-left-md">
            <i className="mediaType-icon users-icon-active padding-right-md"></i>
            {_.get(subject, 'name')}
          </span>
          {false &&
            <span className="more" onClick={() =>
              originDispatch(routeActions.push({
                pathname: '/search',
                query: {
                  subjectId: _.get(subject, 'id'),
                  startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
                  endDate: moment().format("YYYY-MM-DD 23:59:59"),
                }
              }))}>更多</span>
          }
        </div>
        <div>
          <div style={{background: '#fff',paddingTop: "10px", minHeight: '380px'}}>
            <FacebookFeedListContainer dispatch={dispatch} originDispatch={originDispatch}/>
          </div>
        </div>
      </div>
    )
  }
}
export default container(NewsFeedListLayout)



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/FacebookFeedListLayout.js
 **/